// 自定义属性
export let selfAttrList = {
  en: [
    {
      attr: 'THICKNESS',
      attrValue: '',
      value: [
        {
          name: 'Sheer',
          attributeValueId: 'Sheer',
        },
        {
          name: 'Thin',
          attributeValueId: 'Thin',
        },
        {
          name: 'Standard',
          attributeValueId: 'Standard',
        },
        {
          name: 'Thick',
          attributeValueId: 'Thick',
        }
      ]
    },
    {
      attr: 'TOUCH',
      attrValue: '',
      value: [
        {
          name: 'Soft',
          attributeValueId: 'Soft',
        },
        {
          name: 'Moderate',
          attributeValueId: 'Moderate',
        },
        {
          name: 'Hard',
          attributeValueId: 'Hard',
        },
        {
          name: 'Stiff',
          attributeValueId: 'Stiff',
        }
      ]
    },
    {
      attr: 'TYPE',
      attrValue: '',
      value: [
        {
          name: 'Loose',
          attributeValueId: 'Loose',
        },
        {
          name: 'Fit',
          attributeValueId: 'Fit',
        },
        {
          name: 'Slim',
          attributeValueId: 'Slim',
        },
        {
          name: 'Extra-Slim',
          attributeValueId: 'Extra-Slim',
        }
      ]
    },
    {
      attr: 'OFT',
      attrValue: '',
      value: [
        {
          name: 'No',
          attributeValueId: 'No',
        },
        {
          name: 'Micro',
          attributeValueId: 'Micro',
        },
        {
          name: 'Normal',
          attributeValueId: 'Normal',
        },
        {
          name: 'High',
          attributeValueId: 'High',
        }
      ]
    },
  ],
  ger: [
    {
      attr: 'DICKE',
      attrValue: '',
      value: [{
        name: 'Sheer',
        attributeValueId: 'Sheer',
      },
      {
        name: 'Dünn',
        attributeValueId: 'Dünn',
      },
      {
        name: 'Standard',
        attributeValueId: 'Standard',
      },
      {
        name: 'Dick',
        attributeValueId: 'Dick',
      }
      ]
    },
    {
      attr: 'Berühren',
      attrValue: '',
      value: [{
        name: 'Weich',
        attributeValueId: 'Weich',
      },
      {
        name: 'Mäßig',
        attributeValueId: 'Mäßig',
      },
      {
        name: 'Schwer',
        attributeValueId: 'Schwer',
      },
      {
        name: 'Steif',
        attributeValueId: 'Steif',
      }
      ]
    },
    {
      attr: 'TYPE',
      attrValue: '',
      value: [{
        name: 'Loose',
        attributeValueId: 'Loose',
      },
      {
        name: 'Fit',
        attributeValueId: 'Fit',
      },
      {
        name: 'Slim',
        attributeValueId: 'Slim',
      },
      {
        name: 'Extra-Slim',
        attributeValueId: 'Extra-Slim',
      }
      ]
    },
    {
      attr: 'Elastizität',
      attrValue: '',
      value: [{
        name: 'No',
        attributeValueId: 'No',
      },
      {
        name: 'Micro',
        attributeValueId: 'Micro',
      },
      {
        name: 'Normal',
        attributeValueId: 'Normal',
      },
      {
        name: 'Hoch',
        attributeValueId: 'Hoch',
      }
      ]
    },
  ],
  fra: [
    {
      attr: 'ÉPAISSEUR',
      attrValue: '',
      value: [
        {
          name: 'Transparent',
          attributeValueId: 'Transparent',
        },
        {
          name: 'Mince',
          attributeValueId: 'Mince',
        },
        {
          name: 'Standard',
          attributeValueId: 'Standard',
        },
        {
          name: 'Épais',
          attributeValueId: 'Épais',
        }
      ]
    },
    {
      attr: 'TOUCHER',
      attrValue: '',
      value: [
        {
          name: 'Doux',
          attributeValueId: 'Doux',
        },
        {
          name: 'Modéré',
          attributeValueId: 'Modéré',
        },
        {
          name: 'Dur',
          attributeValueId: 'Dur',
        },
        {
          name: 'Raide',
          attributeValueId: 'Raide',
        }
      ]
    },
    {
      attr: 'TYPE',
      attrValue: '',
      value: [
        {
          name: 'Lâches',
          attributeValueId: 'Lâches',
        },
        {
          name: 'Ajusté',
          attributeValueId: 'Ajusté',
        },
        {
          name: 'Mince',
          attributeValueId: 'Mince',
        },
        {
          name: 'Extra-mince',
          attributeValueId: 'Extra-mince',
        }
      ]
    },
    {
      attr: 'ELASTIQUE',
      attrValue: '',
      value: [
        {
          name: 'Non',
          attributeValueId: 'Non',
        },
        {
          name: 'Micro',
          attributeValueId: 'Micro',
        },
        {
          name: 'Normal',
          attributeValueId: 'Normal',
        },
        {
          name: 'Élevée',
          attributeValueId: 'Élevée',
        }
      ]
    },
  ],
  spn: [
    {
      attr: 'ESPESOR',
      attrValue: '',
      value: [
        {
          name: 'Transparente',
          attributeValueId: 'Transparente',
        },
        {
          name: 'Fino',
          attributeValueId: 'Fino',
        },
        {
          name: 'Estándar',
          attributeValueId: 'Estándar',
        },
        {
          name: 'Grueso',
          attributeValueId: 'Grueso',
        }
      ]
    },
    {
      attr: 'TOQUE',
      attrValue: '',
      value: [
        {
          name: 'Suave',
          attributeValueId: 'Suave',
        },
        {
          name: 'Moderado',
          attributeValueId: 'Moderado',
        },
        {
          name: 'Duro',
          attributeValueId: 'Duro',
        },
        {
          name: 'Rígido',
          attributeValueId: 'Rígido',
        }
      ]
    },
    {
      attr: 'TIPO',
      attrValue: '',
      value: [
        {
          name: 'Suelto',
          attributeValueId: 'Suelto',
        },
        {
          name: 'Ajuste',
          attributeValueId: 'Ajuste',
        },
        {
          name: 'Delgado',
          attributeValueId: 'Delgado',
        },
        {
          name: 'Extrafino',
          attributeValueId: 'Extrafino',
        }
      ]
    },
    {
      attr: 'ELÁSTICO',
      attrValue: '',
      value: [
        {
          name: 'No',
          attributeValueId: 'No',
        },
        {
          name: 'Micro',
          attributeValueId: 'Micro',
        },
        {
          name: 'Normal',
          attributeValueId: 'Normal',
        },
        {
          name: 'Alto',
          attributeValueId: 'Alto',
        }
      ]
    },
  ],
  it: [],
  por: [],
  pol: [],
  cn: [],
}
// 自定义label
export let selfLabelList = {
  en: [{ label: 'Fabric' }, { label: 'Color' }, { label: 'Tag Size' }],
  ger: [{ label: 'Material' }, { label: 'Farbe' }, { label: 'Größe' }],
  fra: [{ label: 'Matériau' }, { label: 'Couleur' }, { label: 'Taille' }],
  spn: [{ label: 'Material' }, { label: 'Color' }, { label: 'Talla' }],
  it: [{ label: 'TESSUTO' }, { label: 'COLORE' }, { label: 'TAGLIA TAG' }],
  por: [{ label: 'TECIDO' }, { label: 'COR' }, { label: 'TAMANHO DO TAG' }],
  pol: [{ label: 'TYLKO' }, { label: 'KOLOR' }, { label: 'ROzmiar TAG' }],
  cn: [{ label: '面料' }, { label: '颜色' }, { label: '标签尺寸' }]
}

// 自定义标题
export let selfTitlist = {
  en: [
    {
      title: 'PRODUCT ATTRIBUTES',
    },
    {
      title: 'MEASUREMENT INFORMATION',
    },
    {
      title: 'The size is measured directly on the clothes.',
    },
    {
      title: 'Please allow 1-3cm difference due to manual measurement(note 1cm=0.39inch)',
    }
  ],
  ger: [
    {
      title: 'PRODUKTEIGENSCHAFTEN',
    },
    {
      title: 'MESSINFORMATIONEN',
    },
    {
      title: 'Die Größe wird direkt an der Kleidung gemessen.',
    },
    {
      title: 'Bitte erlauben Sie 1-3 cm Unterschied aufgrund der manuellen Messung (Hinweis 1 cm = 0,39 Zoll)',
    }
  ],
  fra: [
    {
      title: 'ATTRIBUTS DU PRODUIT',
    },
    {
      title: 'INFORMATIONS SUR LES MESURES',
    },
    {
      title: 'La taille est mesurée directement sur les vêtements.',
    },
    {
      title: 'Veuillez permettre des différences de 1 à 3 cm en raison de la mesure manuelle. (1 cm = 0,39 pouce)',
    }
  ],
  spn: [
    {
      title: 'ATRIBUTOS DEL PRODUCTO',
    },
    {
      title: 'INFORMACIÓN DE MEDICIÓN',
    },
    {
      title: 'La talla se mide directamente sobre la ropa.',
    },
    {
      title: 'Permita diferencias de 1-3 cm debido a la medición manual. (1 cm = 0,39 pulgadas)',
    }
  ]
}

export const tableLangInfo = {
  an: {
    headTitle: 'Size-Details',
    otherLabel: {
      an: 'US',
      en: 'UK-AU',
      ger: 'EU-DE',
      fra: 'FR',
      spn: 'ESP',
      it: 'IT',
      por: 'POR',
      pol: 'PL',
      cn: 'CHN',
      name: 'Tag Size',
    }
  },
  en: {
    headTitle: 'Size-Details',
    otherLabel: {
      an: 'US',
      en: 'UK-AU',
      ger: 'EU-DE',
      fra: 'FR',
      spn: 'ESP',
      it: 'IT',
      por: 'POR',
      pol: 'PL',
      cn: 'CHN',
      name: 'Tag Size',
    }
  },
  ger: {
    headTitle: 'Größe-Einzelheiten',
    otherLabel: {
      an: 'US Größe',
      en: 'UK Größe',
      ger: 'EU Größe',
      fra: '',
      spn: '',
      it: '',
      por: '',
      pol: '',
      cn: '',
      name: 'Etikettengröße',
    }
  },
  fra: {},
  spn: {},
  it: {},
  por: {},
  pol: {},
  cn: {
    headTitle: '尺码信息',
    otherLabel: {
      an: '',
      en: '',
      ger: '',
      fra: '',
      spn: '',
      it: '',
      por: '',
      pol: '',
      cn: '',
      name: 'Tag Size',
    }
  },
  default: {
    headTitle: 'Size-Details',
    otherLabel: {
      an: 'Tag Size',
      en: 'Tag Size',
      ger: '',
      fra: '',
      spn: '',
      it: '',
      por: '',
      pol: '',
      cn: '',
      name: 'Tag Size'
    }
  }
}
